import {Locales} from '@netx/core-next/locales/utils/Locales';
import {
	FileAspectType,
	FileAspectSubType,
	FileAspectOrientationValue,
} from './constants';

export const FileAspectTypeLabel: Record<FileAspectType, string> = Locales(
	(i18n) => ({
		[FileAspectType.DURATION]: i18n('i18n.durationSeconds'),
		[FileAspectType.HEIGHT]: i18n('i18n.height'),
		[FileAspectType.ORIENTATION]: i18n('i18n.orientation'),
		[FileAspectType.WIDTH]: i18n('i18n.width'),
	}),
);

export const FileAspectSubTypeLabel: Record<FileAspectSubType, string> =
	Locales((i18n) => ({
		[FileAspectSubType.APPROXIMATELY]: i18n('i18n.approximately'),
		[FileAspectSubType.EQUAL_TO]: i18n('i18n.equalTo'),
		[FileAspectSubType.GREATER_THAN]: i18n('i18n.greaterThan'),
		[FileAspectSubType.LESS_THAN]: i18n('i18n.lessThan'),
	}));

export const FileAspectOrientationValueLabel: Record<
	FileAspectOrientationValue,
	string
> = Locales((i18n) => ({
	[FileAspectOrientationValue.LANDSCAPE]: i18n('i18n.landscape'),
	[FileAspectOrientationValue.PORTRAIT]: i18n('i18n.portrait'),
}));
